import { createContext } from "react";
const PageApplicantContext = createContext();
export default PageApplicantContext;
